import { Directive, Input, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { FormControlName, NgModel } from '@angular/forms';
//Floating input Directive for making text float when using reactive form
@Directive({
    selector: '[floatinput]',
    providers: [FormControlName],
    host: {
        '(ngModelChange)': 'onInputChange($event)',
        '(focusout)': 'onBlur($event)'
    }
})
export class FloatInputDirective implements OnInit {
    @Input('myOptional') private controlValue: string;
    constructor(private el: ElementRef, private model: FormControlName) {
        if (this.el.nativeElement && this.el.nativeElement.value) {
            if (this.el.nativeElement.value) {
                this.el.nativeElement.value.trim();
            }
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (lbl)
                lbl.classList.add('label-active');
        }
        else {
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (lbl)
                lbl.classList.remove('label-active');
        }
    }
    ngOnInit(): void {
        if (this.model.valueChanges)
            this.model.valueChanges.subscribe((e) => {
                this.onInputChange(e);
            });
    }
    onInputChange(event) {
        
        if (this.el.nativeElement && (this.el.nativeElement.value || event)) {
            if (this.el.nativeElement.tagName.toLowerCase() == "select" && this.el.nativeElement.options.length > 1) {
                var match = 0;
                var options = this.el.nativeElement.options;
                for (let i = 0; i < options.length; i++) {
                    var element = options[i];
                    match += (element.value == (event ? event : this.el.nativeElement.value) ? 1 : 0);
                }
                if (match == 0)
                    return false;
            }
            if (this.el.nativeElement.value) {
                this.el.nativeElement.value.trim();
            }
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (lbl)
                lbl.classList.add('label-active');
        }
        else {
            
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (this.el.nativeElement.tagName.toLowerCase() == "select" && lbl){
                lbl.classList.add('label-active');
            }
            else if (lbl)
                lbl.classList.remove('label-active');
        }
    }
    onBlur(event) {
        // if (this.el.nativeElement.value) {
        //     this.el.nativeElement.value = this.el.nativeElement.value.trim();
        //     this.el.nativeElement.dispatchEvent(new Event('input'))
        // }
    }
    ngAfterViewInit() {
        this.onInputChange(null);
    }
}

//Trim Directive to trim text on blur
@Directive({
    selector: '[formControlName]',
    providers: [FormControlName],
    host: {
        '(focusout)': 'onBlur($event)'
    }
})
export class TrimDirective implements OnInit {
    constructor(private el: ElementRef, private model: FormControlName) {
    }
    ngOnInit(): void {
    }
    onBlur(event) {
        if (this.el.nativeElement.value) {
            this.el.nativeElement.value = this.el.nativeElement.value.trim();
            this.el.nativeElement.dispatchEvent(new Event('input'))
        }
    }
}


//Floating input Directive for making text float when using ngModel
@Directive({
    selector: '[floatinputModel]',
    providers: [FormControlName],
    host: {
        '(ngModelChange)': 'onInputChange($event)',
        '(focusout)': 'onBlur($event)'
    }
})
export class FloatInputDirectiveForNgModel implements OnInit {
    @Input('myOptional') private controlValue: string;
    constructor(private el: ElementRef, private model: NgModel) {
        if (this.el.nativeElement && (this.el.nativeElement.value || event)) {
            if (this.el.nativeElement.value) {
                // this.model.control.setValue(this.el.nativeElement.value.trim());
            }
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (lbl)
                lbl.classList.add('label-active');
        }
        else {
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (lbl)
                lbl.classList.remove('label-active');
        }
    }
    ngOnInit(): void {
        if (this.model.valueChanges)
            this.model.valueChanges.subscribe((e) => {
                this.onInputChange(e);
            });
    }
    onInputChange(event) {
        
        if (this.el.nativeElement && (this.el.nativeElement.value || event)) {
            if (this.el.nativeElement.value) {
                //this.model.control.setValue(this.el.nativeElement.value.trim());
            }
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (lbl)
                lbl.classList.add('label-active');
        }
        else {
            let lbl = this.el.nativeElement.parentElement.querySelector('label');
            if (this.el.nativeElement.tagName.toLowerCase() == "select" && lbl){
                lbl.classList.add('label-active');
            }
            else if (lbl)
                lbl.classList.remove('label-active');
        }
    }

    onBlur(event) {
        if (this.el.nativeElement.value) {
            this.model.control.setValue(this.el.nativeElement.value.trim());
        }
    }

    ngAfterViewInit() {
        this.onInputChange(null);
    }
}